<template>
  <div
    class="game-content"
    @contextmenu="handler($event)">
    <game-header />
    <betting />
  </div>
</template>

<script>
import GameHeader from '../components/shop/main/GameHeader.vue';
import Betting from '../components/shop/main/Betting.vue';
import { GatewaySvc } from '../services/gateway.service';
import ticketActions from '../model/ticketActions';
import { TranslationSvc } from '../services/translation.service';
import { EventBus } from '../utilities/event.bus';
import { BettingSvc } from '../services/betting.service';

export default {
  name: 'Game',
  components: {
    GameHeader,
    Betting,
  },

  methods: {
    handler(e) {
      e.preventDefault();
    },
  },

  beforeCreate() {
    const initializeShortcuts = () => {
      function modifyTicketActions(ticketActions) {
        var companyUuid = sevenConfig.data.company.uuid;

        var modifiedClientConfig = {
          'eb6e0c29-30a9-46b8-b1b1-4b541af6646c': {
            // Fortuna CZ 2
            open: [
              { action: 'printCopy', conditions: [] },
              { action: 'rebet', conditions: [] },
            ],
          },
          'ced86bdf-e2c6-4c7c-8144-041f702b9c7d': {
            // Fortuna CZ Test prod.
            open: [
              { action: 'printCopy', conditions: [] },
              { action: 'rebet', conditions: [] },
            ],
          },
          'c9e2d5bb-0341-48b4-a741-d5320edd1915': {
            // Fortuna CZ Prod.
            open: [
              { action: 'printCopy', conditions: [] },
              { action: 'rebet', conditions: [] },
            ],
          },
        };

        if (companyUuid in modifiedClientConfig) {
          for (var i in modifiedClientConfig[companyUuid]) {
            if (i in ticketActions) {
              ticketActions[i] = modifiedClientConfig[companyUuid][i];
            }
          }
        }

        return ticketActions;
      }

      let shortcuts = {
        '+': {
          action: 'Standard',
          active: true,
          name: TranslationSvc.getTranslation('normal_bet'),
          shortcut: '+',
        },
        r: {
          action: 'Standard',
          active: true,
          name: TranslationSvc.getTranslation('random'),
          shortcut: 'r',
        },
        w: {
          action: 'Standard',
          active: true,
          name: TranslationSvc.getTranslation('random_system'),
          shortcut: 'w',
        },
        s: {
          action: 'Standard',
          active: true,
          name: TranslationSvc.getTranslation('system_bet'),
          shortcut: 's',
        },
        f: {
          action: 'Future',
          active: true,
          name: TranslationSvc.getTranslation('future_bet'),
          shortcut: 'f',
        },
        q: {
          action: 'Standard',
          active: true,
          name: TranslationSvc.getTranslation('results'),
          shortcut: 'q',
        },
        '/': {
          action: 'Standard',
          active: true,
          name: TranslationSvc.getTranslation('reset_betslip'),
          shortcut: '/',
        }
      };

      const bindings = BettingSvc.getBettingSvc().shortcutBindings;
      for (let i in sevenConfig.data.config.bets) {
        let confBet = sevenConfig.data.config.bets[i];

        if (bindings[confBet.id] && confBet.value) {
          shortcuts[bindings[confBet.id]] = {
            action: 'Standard',
            active: confBet.value,
            name: confBet.name,
            shortcut: bindings[confBet.id],
          };
        }
      }

      GatewaySvc.getGatewaySvc().sendMessage('Product:UpdateSettings', {
        ticketConfig: {
          color: '#1b8a93',
          useTicketLocalStorage: true,
          doTicketStatusCheck: true,
          pendingTicketLimitTotal: 100,
          pendingTicketLimitByGame: 1,
          pendingTicketCheckInterval: 15000,
          pendingTicketRejectPeriod: 60000,
          sentTicketRejectPeriod: 10000,
          availableTicketActions: modifyTicketActions(ticketActions),
          validateTicket: false,
        },
        shortcuts: shortcuts,
        icon: 'n-i-keno',
      });

      EventBus.$emit('SendSlaveLoaded');
    }
    const waitForTranslations = () => {
      if (TranslationSvc.translationsLoaded) {
        initializeShortcuts();
      } else {
        setTimeout(() => waitForTranslations(), 200);
      }
    }
    waitForTranslations();
  },

  mounted() {
    EventBus.$emit('keydown', {
      key: '+',
    });
  },
};
</script>
<style  lang="scss">
@import '../assets/style/shop/variables';

div {
  color: $bet;
}
</style>



// WEBPACK FOOTER //
// Shop.vue?a796cf92